import { useState } from "react";
import PayementAvanceChargePrelevementFN from "./PayementMethods/PayementAvanceChargePrelevementFN";
import PayementTotalChargeVirementFN from "./PayementMethods/PayementTotalChargeVirementFN";
import PayementAvanceChargeEspeceFN from "./PayementMethods/PayementAvanceChargeEspeceFN";
import PayementAvanceChargeEnLigneFN from "./PayementMethods/PayementAvanceChargeEnLigneFN";
import PayementAvanceChargeChequeFN from "./PayementMethods/PayementAvanceChargeChequeFN";
import PayementAvanceChargeVirementFN from "./PayementMethods/PayementAvanceChargeVirementFN";



const MethodePayementChargeAvance=()=>{
    const [methodePayement, setMethodePayement] = useState("");

    const createUIPayement = () => {
      if (methodePayement === "CHEQUE") {
          return <PayementAvanceChargeChequeFN />;
      } else if (methodePayement === "ENLIGNE") {
          return <PayementAvanceChargeEnLigneFN />;
      } else if (methodePayement === "ESPECE") {
          return <PayementAvanceChargeEspeceFN/>;
      } else if (methodePayement === "VIREMENT") {
          return <PayementAvanceChargeVirementFN />;
      } else if (methodePayement === "PRELEVEMENT") {
          return <PayementAvanceChargePrelevementFN />;
      }
    };
    const handleChangePayement = (e) => {
      let payement = e.target.value;
      setMethodePayement(payement);
    };
     const listOptionsPayement = () => {
    if (localStorage.getItem("status").includes("ADMIN")) {

    return (
      <select class="form-control" onChange={handleChangePayement}>
        <option key={0} value={0}>
          Sélectionner un mode de payement
        </option>
        <option key={1} value={"ESPECE"}>
          Espèce
        </option>
        <option key={2} value={"ENLIGNE"}>
          En ligne
        </option>
        <option key={3} value={"CHEQUE"}>
          Chèques / Traites
        </option>
        <option key={4} value={"VIREMENT"}>
          Virement
        </option>
        <option key={6} value={"PRELEVEMENT"}>
          Prélèvement
        </option>
      </select>
    );
  }else if(localStorage.getItem("status").includes("DIRECTEUR_MAGASIN")){
      return (
      <select class="form-control" onChange={handleChangePayement}>
        <option key={0} value={0}>
          Sélectionner un mode de payement
        </option>
        <option key={1} value={"ESPECE"}>
          Espèce
        </option>
      </select>
    );
  }
  };
    return (
      <div className="card-body">
        <h5 className="card-title">Choisir le mode de payement </h5>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-10">{listOptionsPayement()}</div>
        </div>
  
        {createUIPayement()}
        <br />
      </div>
    );


}
export default MethodePayementChargeAvance;